import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M29 4H3a1 1 0 00-1 1v8a1 1 0 001 1h1v11a3 3 0 003 3h18a3 3 0 003-3V14h1a1 1 0 001-1V5a1 1 0 00-1-1zm-1 8H4V6h24zm-2 13a1 1 0 01-1 1H7a1 1 0 01-1-1V14h20z"/><path d="M13 21h6a3 3 0 003-3 1 1 0 00-2 0 1 1 0 01-1 1h-6a1 1 0 01-1-1 1 1 0 00-2 0 3 3 0 003 3z"/>';
export var ArchiveOutlineSVG = function ArchiveOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ArchiveOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ArchiveOutlineSVG);